/**
 * Represents the 'type' of item that the route is referring to.
 * Used for both lister and dashboard routes.
 * Can be None if the dashboard does represent a particular type of thing. e.g Admin dashboards
 */
export type RouteContextItemType =
  | 'None'
  | 'Client'
  | 'ClientParent'
  | 'Creditor'
  | 'Debtor'
  | 'Estate'
  | 'Headlease'
  | 'Landlord'
  | 'Lease'
  | 'Manager'
  | 'Property'
  | 'Supplier'
  | 'Tenant'
  | 'TenantParent'
  | 'Unit'
  | 'Vacant'
  | 'Agreement'
  | 'Account'
  ;

interface HasRouteContextItemType {
  routeContextItemType: RouteContextItemType;
}

// These classes have static methods to allow them to be constructed in angular AOT scenarios (like route config)
export class DashboardRouteContext implements HasRouteContextItemType  {
  readonly kind = 'DashboardRouteContext';

  static create(routeContextItemType: RouteContextItemType, allowWidgetAdd = true): DashboardRouteContext {
    return  {
      kind: 'DashboardRouteContext',
      routeContextItemType: routeContextItemType,
      allowWidgetAdd: allowWidgetAdd
    };
  }

  constructor(
    public routeContextItemType: RouteContextItemType,
    public allowWidgetAdd: boolean = false) {
  }

}

// These classes have static methods to allow them to be constructed in angular AOT scenarios (like route config)
export class ListerRouteContext implements HasRouteContextItemType   {

  readonly kind = 'ListerRouteContext';

  get routeContextItemType(): RouteContextItemType {
    return this.allType;
  }

  static all(allType: RouteContextItemType): ListerRouteContext {
    return {
      kind: 'ListerRouteContext',
      routeContextItemType: allType,
      allType: allType,
      forType: null
    };
  }

  static allFor(allType: RouteContextItemType, forType: RouteContextItemType) {
    return {
      kind: 'ListerRouteContext',
      routeContextItemType: allType,
      allType: allType,
      forType: forType
    };
  }

  constructor( public allType?: RouteContextItemType, public  forType?: RouteContextItemType ) {}

}

export type RouteContext =
  | ListerRouteContext
  | DashboardRouteContext;
